export const SET_USER = 'SET_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const SET_ACCOUNTS = 'SET_ACCOUNTS';
export const CLEAR_ACCOUNTS = 'CLEAR_ACCOUNTS';

